import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import DingTalkLogin from '@/components/DingTalkLogin'
import Home from '@/components/Home.vue'
import UserManage from '@/components/UserManage.vue'
import ServerManage from '@/components/ServerManage.vue'
import CustomerManage from '@/components/CustomerManage.vue'
import ActionLogManage from '@/components/ActionLogManage.vue'
import ErrorLogManage from '@/components/ErrorLogManage.vue'
import RockeyManage from '@/components/RockeyManage.vue'
import MQMonitor from '@/components/MQMonitor.vue'
import StorageMonitor from '@/components/StorageMonitor.vue'
import StorageRank from '@/components/StorageRank.vue'
import WeiXinRemindMonitor from '@/components/WeiXinRemindMonitor.vue'
import WeiXinRemindRank from '@/components/WeiXinRemindRank.vue'
import WorkItemManage from '@/components/WorkItemManage.vue'
import ESignDetailView from '@/components/ESignDetailView.vue'
import AgentManage from '@/components/AgentManage.vue'
import DataSourceManage from '@/components/DataSourceManage.vue'
import TaskManage from '@/components/TaskManage.vue'
import ModelEditor from '@/components/ModelEditor.vue'
import TaskExecuteState from '@/components/TaskExecuteState.vue'





Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
      hidden: true
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      hidden: true
    },
    {
      path: '/dingtalklogin',
      name: 'dingtalklogin',
      component: DingTalkLogin,
      hidden: true
    },
    {
      path: '/home',
      name: '系统管理',
      component: Home,
      iconCls: 'el-icon-setting',
      children: [
        { path: '/userManage', component: UserManage, name: '用户管理', prcode: 'User' },
        { path: '/serverManage', component: ServerManage, name: '服务器管理', prcode: 'Server' },
        { path: '/rockeyManage', component: RockeyManage, name: '加密锁管理', prcode: 'Rockey' }
      ]
    },
    {
      path: '/home',
      name: '服务管理',
      component: Home,
      iconCls: 'el-icon-share',
      children: [
        { path: '/customerManage', component: CustomerManage, name: '服务实例', prcode: 'Customer' },
        { path: '/publishManage', component: ServerManage, name: '发布管理', prcode: 'Publish' }        
      ]
    },
    {
      path: '/home',
      name: '服务监控',
      component: Home,
      iconCls: 'fa fa-bar-chart',
      children: [
        { path: '/actionLogManage', component: ActionLogManage, name: '操作日志', prcode: 'ActionLog' },
        { path: '/errorLogManage', component: ErrorLogManage, name: '错误日志', prcode: 'ErrorLog' },
        { path: '/mqMonitor', component: MQMonitor, name: '队列监控', prcode: 'MQMonitor' },
        { path: '/storageMonitor', component: StorageMonitor, name: '存储监控', prcode: 'StorageMonitor' },
        // { path: '/storageMonitor/:code', component: StorageMonitor, name: '存储监控', prcode: 'StorageMonitor', hidden: true },
        { path: '/storageRank', component: StorageRank, name: '存储排行', prcode: 'StorageMonitor' },
        { path: '/weiXinRemindMonitor', component: WeiXinRemindMonitor, name: '提醒监控', prcode: 'WeiXinRemindMonitor' },
        { path: '/weiXinRemindRank', component: WeiXinRemindRank, name: '提醒排行', prcode: 'WeiXinRemindMonitor' },
        { path: '/eSignDetailView', component: ESignDetailView, name: 'E签宝明细', prcode: 'ESignDetailView' }
      ]
    },
    {
      path: '/home',
      name: '需求管理',
      component: Home,
      iconCls: 'fa fa-tasks',
      children: [
        { path: '/workItemManage', component: WorkItemManage, name: '需求管理', prcode: 'WorkItem' }
      ]
    },
    {
        path: '/home',
        name: '数据采集',
        component: Home,
        iconCls: 'el-icon-coin',
        children: [
            { path: '/agentmanage', component: AgentManage, name: '代理管理', prcode: 'Agent' },
            { path: '/taskmanage', component: TaskManage, name: '任务管理', prcode: 'Task' },
            { path: '/taskexecutestate/:taskId', component: TaskExecuteState, name: '任务执行', prcode: 'Task', hidden: true, taskId: 0 },
            { path: '/datasourcemanage/:agentId', component: DataSourceManage, name: '数据源', prcode: 'Agent', hidden: true, agentId: 0 },
            { path: '/modeleditor/:taskId', component: ModelEditor, name: '模型编辑', prcode: 'Task', hidden: true, taskId: 0 }

            

        ]
    }

  ]
})
